import { getEndpoint } from "./endpoint";

const MS_NAME = "address-finder";

export const getEircodeFinderRoute = (eircode: string) => `${getEndpoint(MS_NAME)}address?eircode=${eircode}`;
